<template>
    <div v-if="data" class="z-70 fixed fixed top-0 left-0 w-full h-full flex items-center justify-center">
        <div @click="data = null" class="absolute top-0 left-0 w-full h-full bg-blue-400 z-70 opacity-50"></div>
        <div class="bg-white relative z-70 shadow-lg rounded-lg w-full max-w-6xl">
            <div class="p-8">
                <div>
                    <vue-dropzone class="bg-gray-200 p-8 rounded-lg shadow-none border-2 border-dashed flex items-center justify-center" ref="myVueDropzone" id="dropzone"  v-on:vdropzone-success="allowSaveFile" :options="dropzoneOptions"></vue-dropzone>
                </div>
                <div v-if="data.config.rellena_fecha_caducidad">
                    <datepicker class="my-vue-datepicker input w-full bg-gray-200 border mt-2" placeholder="Indicar fecha de caducidad del documento aportado" v-model="fecha_caducidad" :format="customFormatter"></datepicker>
                </div>
                <button v-bind:class="{'opacity-50 cursor-not-allowed': !canSaveFile, 'cursor-pointer': canSaveFile}" @click="canSaveFile && saveFile()" class="ml-auto mt-4 dropdown-toggle button text-white bg-theme-1 shadow-md flex items-center"> 
                    <PlusIcon class="mr-2"/>
                    Subir Documento
                </button>
            </div>
        </div>
    </div>
</template>
<style scope>
.my-vue-datepicker input {background: none; width: 100%;}
</style>
<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker: Datepicker
    },
    data() {
        return {
            data: null,
            canSaveFile: false,
            fecha_caducidad: null,
            notification: {
                uploadFile: "Se ha subido el archivo a {FILENAME}."
            },
            dropzoneOptions: {
                url: '/file-upload/',
                thumbnailWidth: 150,
                maxFilesize: 10,
                acceptedFiles: 'application/pdf',
                headers: { "My-Awesome-Header": "header value" },
                dictDefaultMessage: `
                    <div class="flex justify-center items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 w-20 h-20 text-gray-300 feather feather-file"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg>
                        <p class="text-gray-600">Arrastra o haz clic para subir el documento seleccionado</p>
                    </div>
                `,
                dictFallbackMessage: "Tu navegador no soporta la subida de archivos mediante arrastrar y soltar.",
                dictFallbackText: "Por favor, usa el siguiente formulario para subir tus archivos como en los viejos tiempos.",
                dictFileTooBig: "El archivo es demasiado grande ({{filesize}}MiB). Tamaño máximo de archivo: {{maxFilesize}}MiB.",
                dictInvalidFileType: "No puedes subir archivos de este tipo.",
                dictResponseError: "El servidor respondió con el código {{statusCode}}.",
                dictCancelUpload: "Cancelar la carga",
                dictCancelUploadConfirmation: "¿Estás seguro de que quieres cancelar esta subida?",
                dictRemoveFile: "Eliminar el archivo",
                dictMaxFilesExceeded: "No puedes subir más archivos.",
            }
        };
    },
    mounted() {
        window.bus.$on("modalUploadFile", (data) => {
            this.data = data;
            this.fecha_caducidad = this.data.fecha_caducidad ? this.data.fecha_caducidad : null;
            this.data.fecha_caducidad = this.fecha_caducidad;
            if(this.data.autosave_file) {
                this.saveFile();
            }
            console.log(this.data);
        });
    },
    watch: {
        fecha_caducidad: {
            handler(newVal, oldVal) {
                this.data.fecha_caducidad = newVal ? moment(newVal).format('YYYY-MM-DD HH:mm:ss') : null;
                console.log('cambio fecha cadu', this.data.fecha_caducidad);
            },
            deep: true
        }
    },
    methods: {
        customFormatter(date) {
            return moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
        allowSaveFile(file, response) {
            try {
                response = JSON.parse(response);
                if(response.data && response.data[0]) {
                    this.data.urlPath = response.data[0].urlPath;
                    this.data.filePath = response.data[0].filePath;
                    this.canSaveFile = true;
                }
            } catch(error) {
                console.error({'response': response, 'error': error});
            }
        },
        async saveFile() {
            let response = await CmsApi.hook('/hooks/saveFile/', {'data': JSON.stringify(this.data)});
            if(response.success) {
                var notification = this.notification.uploadFile;
                notification = notification.replace("{FILENAME}", this.data.fileName);
                this.generateNotification(this.data.recordNum, notification);
                this.data.files[this.data.order] = {
                    reason: this.data.info3,
                    state: this.data.info2,
                    urlPath: this.data.urlPath,
                    createdDate: response.data.createdTime,
                    fecha_caducidad: response.data.fecha_caducidad,
                    urlForDownload: response.data.urlForDownload,
                };
                this.data.callback(this.data.files ? this.data.files : {});
                this.data = null;
                this.canSaveFile = false;
                window.bus.$emit('reloadDataFromServer');
            } else {
                alert('Ha habido un error con la subida del archivo, si este error persiste contacte con el administrador y facilítele el archivo que trata de subir');
            }
        }
    }
};
</script>